import React from "react";
import { useParams } from "react-router-dom";
import { AppContext } from "@lib/types/Context";
import { SharedPaymentTransactionConfigs } from "@app/shared";

const PaymentProviderPaymentTransactionConfigs: React.FC = () => {
  const { providerId } = useParams();

  // Check if user has permission to view wallet pool
  // if (!permissions.canViewWalletPool) {
  //   return <NoPermission />;
  // }

  return (
    <SharedPaymentTransactionConfigs
      context={AppContext.PAYMENT_PROVIDER}
      providerId={providerId}
    />
  );
};

export default PaymentProviderPaymentTransactionConfigs;
